import React from 'react';
import { ModalsKeys } from 'global';
import { Add } from '@mui/icons-material';
import { useModal } from 'hooks/useModal';
import { Button, Stack } from '@mui/material';

export const CalendarActions = () => {
  const { handleOpen } = useModal(ModalsKeys.CreateEventDialog);

  return (
    <Stack direction="row" justifyContent="flex-end">
      <Button startIcon={<Add />} size="small" variant="contained" onClick={() => handleOpen()}>
        New Event
      </Button>
    </Stack>
  );
};
